const SchoolBoard = [
  { label: "CBSE", value: "1" },
  { label: "ICSE", value: "2" },
  { label: "State Board", value: "3" },
];

export default SchoolBoard;
